/**
 * أدوات تنسيق للعرض فقط. لا تحتوي أي منطق تقييم.
 * الأرقام لاتينية دائماً داخل المنتج (قاعدة طباعية مثبّتة).
 */

const nf = new Intl.NumberFormat('en-US');

export function num(n: number): string {
  return nf.format(Math.round(n));
}

export function sar(n: number): string {
  return `${num(n)} ر.س`;
}

export function perSqm(n: number): string {
  return `${num(n)} ر.س/م²`;
}

export function pct(n: number, digits = 1): string {
  return `${n > 0 ? '+' : ''}${n.toFixed(digits)}%`;
}

export function pctAbs(n: number, digits = 1): string {
  return `${Math.abs(n).toFixed(digits)}%`;
}

/** مبلغ مختصر: 4.8M / 750K */
export function compactSar(n: number): string {
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(n >= 10_000_000 ? 0 : 1)}M ر.س`;
  if (n >= 1_000) return `${Math.round(n / 1_000)}K ر.س`;
  return sar(n);
}

/** تاريخ ميلادي مختصر بالأرقام اللاتينية. */
export function shortDate(iso: string): string {
  return iso.slice(0, 10);
}

/** نص «غير متاح» الموحّد — يظهر بدل أي رقم غير مشتق من المصدر. */
export const UNAVAILABLE = '—';

export function numOrDash(n: number | null | undefined): string {
  return n === null || n === undefined ? UNAVAILABLE : num(n);
}

export function perSqmOrDash(n: number | null | undefined): string {
  return n === null || n === undefined ? UNAVAILABLE : perSqm(n);
}

export function pctOrDash(n: number | null | undefined, digits = 1): string {
  return n === null || n === undefined ? UNAVAILABLE : pct(n, digits);
}

export function scoreOrDash(n: number | null | undefined): string {
  return n === null || n === undefined ? UNAVAILABLE : String(n);
}
